import {useEffect, useState} from 'react';
import backIcon from 'images/back.png';
import styles from './editNews.module.scss';
import UploadImage from 'components/Startup/profile/companyImage';
import {DatePicker, Form, Input, Select, Spin, Switch} from 'antd';
import {useMutation, useQuery} from '@apollo/client';
import {GET_ALL_TOPICS} from 'graphql/queries/investorUpdates';
import {GET_ALL_STARTUPS} from 'graphql/queries/startupCompanies';
import {useNavigate, useParams} from 'react-router-dom';
import {EDIT_NEWS} from 'graphql/mutations/news';
import moment from 'moment';
import {toast} from 'react-toastify';
import {GET_ALL_NEWS, GET_NEWS_BY_ID} from 'graphql/queries/news';
import {Button} from '@dabafinance/react-components';

const EditNews = () => {
  const [title, setTitle] = useState('');
  const [imgUrl, setImgUrl] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [sourceURL, setSourceURL] = useState('');
  const [source, setSource] = useState('');
  const [trendingNews, setTrendingNews] = useState(false);
  const [selectedNews, setSelectedNews] = useState(false);
  const [keywords, setKeywords] = useState([]);
  const [breakingNews, setBreakingNews] = useState(false);
  const [newsUrl, setNewsUrl] = useState('');
  const [publishedDate, setPublishedDate] = useState('');
  const [topics, setTopics] = useState([]);
  const [companies, setCompanies] = useState([]);
  const {Option} = Select;

  const navigate = useNavigate();
  const {id} = useParams();

  const {data, loading} = useQuery(GET_NEWS_BY_ID, {
    variables: {
      newsId: id,
    },
  });

  useEffect(() => {
    setImgUrl(data?.getNewsById?.news?.featuredImage);
    setPreviewUrl(data?.getNewsById?.news?.featuredImage);
    setTitle(data?.getNewsById?.news?.title);
    setBreakingNews(data?.getNewsById?.news?.isBreakingNews);
    setTrendingNews(data?.getNewsById?.news?.isTrendingNews);
    setSelectedNews(data?.getNewsById?.news?.isSelectedNews);
    setNewsUrl(data?.getNewsById?.news?.link);
    setSourceURL(data?.getNewsById?.news?.newsSource.url);
    setSource(data?.getNewsById?.news?.newsSource?.name);
    setPublishedDate(data?.getNewsById?.news?.publishedDate);
    setCompanies(data?.getNewsById?.news?.companies?.map(name => name.name));
    setTopics(data?.getNewsById?.news?.topics?.map(name => name.name));
    setKeywords(data?.getNewsById?.news?.keywords?.map(name => name));
    if (
      data?.getNewsById?.news?.isBreakingNews === null ||
      data?.getNewsById?.news?.isTrendingNews === null ||
      data?.getNewsById?.news?.isSelectedNews === null
    ) {
      setBreakingNews(false);
      setTrendingNews(false);
      setSelectedNews(false);
    } else {
      setBreakingNews(data?.getNewsById?.news?.isBreakingNews);
      setTrendingNews(data?.getNewsById?.news?.isTrendingNews);
      setSelectedNews(data?.getNewsById?.news?.isSelectedNews);
    }
  }, [data?.getNewsById?.news]);

  const [updateNews] = useMutation(EDIT_NEWS);

  const handleAddNews = () => {
    const optionalField = {};
    if (imgUrl) optionalField.featuredImage = imgUrl;
    updateNews({
      variables: {
        newsId: id,
        data: {
          title,
          link: newsUrl,
          topics,
          newsSource: {
            name: source,
            url: sourceURL,
          },
          companies,
          isTrendingNews: trendingNews,
          isBreakingNews: breakingNews,
          isSelectedNews: selectedNews,
          publishedDate: moment(publishedDate).format(),
          keywords,
          ...optionalField,
        },
      },
      refetchQueries: [{query: GET_ALL_NEWS}],
    })
      .then(({data: {updateNews}}) => {
        if (updateNews.__typename === 'Error') {
          toast.error(updateNews.message);
        } else {
          toast.success('Added Successfully');
          navigate('/dashboard/news');
        }
      })
      .catch(error => toast.error(error));
  };

  const {data: getAllTopics} = useQuery(GET_ALL_TOPICS);
  const {data: getAllCompanies} = useQuery(GET_ALL_STARTUPS);
  const width = 730;

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img onClick={() => navigate(-1)} src={backIcon} alt="" />
        <h2>Update News</h2>
      </div>
      <div className={styles.content}>
        <div className={styles['image-wrapper']}>
          <h1>News Details</h1>
          <UploadImage
            setImgUrl={setImgUrl}
            previewUrl={previewUrl}
            setPreviewUrl={setPreviewUrl}
            large
            bucket="investor-updates-bucket"
          />
        </div>
        <Form layout="vertical">
          <Form.Item label="Title" name="title">
            <Input
              value={title}
              onChange={e => setTitle(e.target.value)}
              defaultValue={data?.getNewsById?.news?.title}
              style={{width}}
              placeholder="News Title"
            />
          </Form.Item>
          <Form.Item label="News URL" name="news url">
            <Input
              value={newsUrl}
              onChange={e => setNewsUrl(e.target.value)}
              style={{width}}
              defaultValue={data?.getNewsById?.news?.link}
              placeholder="https://www.addnews.com"
            />
          </Form.Item>
          <div className={styles.alignment}>
            <Form.Item name="source" label="Source">
              <Input
                style={{width: 360}}
                value={source}
                defaultValue={data?.getNewsById?.news?.newsSource?.name}
                onChange={e => setSource(e.target.value)}
              />
            </Form.Item>
            <Form.Item name="source url" label="Source URL">
              <Input
                style={{width: 340}}
                value={sourceURL}
                defaultValue={data?.getNewsById?.news?.newsSource?.url}
                onChange={e => setSourceURL(e.target.value)}
              />
            </Form.Item>
          </div>
          <div className={styles.alignment}>
            <Form.Item label="Keywords" name="keywords">
              <Select
                style={{width: 360}}
                value={keywords}
                defaultValue={data?.getNewsById?.news?.keywords?.map(
                  name => name,
                )}
                onChange={e => setKeywords(e)}
                mode="multiple"
                className={styles['select-height']}>
                {getAllTopics?.getAllTopics?.map(topic => (
                  <Option key={topic.name}>
                    <span>{topic.name}</span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="published date" label="Published Time">
              <DatePicker
                name="published Date"
                value={publishedDate}
                style={{width: 340}}
                defaultValue={moment(
                  data?.getNewsById?.news?.publishedDate,
                  'YYYY-MM-DD HH:mm:ss',
                )}
                format={'YYYY-MM-DD HH:mm:ss'}
                showTime={{
                  defaultValue: moment('00:00', 'HH:mm:ss'),
                }}
                onChange={e =>
                  setPublishedDate(moment(e).format('YYYY-MM-DD HH:mm:ss'))
                }
              />
            </Form.Item>
          </div>
          <Form.Item label="Categories" name="categories">
            <Select
              style={{width}}
              value={topics}
              onChange={e => setTopics(e)}
              defaultValue={data?.getNewsById?.news?.topics
                ?.filter(name => name.name !== null)
                .map(name => name.name)}
              mode="multiple"
              className={styles['select-height']}>
              {getAllTopics?.getAllTopics?.map(topic => (
                <Option key={topic.name}>
                  <div className={styles['all-data']}>
                    <img src={topic.icon} alt="" />
                    <span>{topic.name}</span>
                  </div>
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Companies" name="companies">
            <Select
              style={{width}}
              listHeight={400}
              className={styles['select-height']}
              value={companies}
              defaultValue={data?.getNewsById?.news?.companies
                ?.filter(name => name.name !== null)
                .map(name => name.name)}
              onChange={e => setCompanies(e)}
              mode="multiple">
              {getAllCompanies?.getAllCompanies?.map(company => (
                <Option key={company.name}>
                  <div className={styles['all-data']}>
                    <img src={company.logoImgURL} alt="" />
                    <span>{company.name}</span>
                  </div>
                </Option>
              ))}
            </Select>
          </Form.Item>
          <div className={styles['audience-grid']}>
            <Form.Item className={styles.audience} name="Verified Investors">
              <span>Breaking News</span>
              <Switch
                value={breakingNews}
                defaultChecked={data?.getNewsById?.news?.isBreakingNews}
                onChange={e => setBreakingNews(e)}
              />
            </Form.Item>
            <Form.Item className={styles.audience} name="All Investors">
              <span>Trending News</span>
              <Switch
                value={trendingNews}
                defaultChecked={data?.getNewsById?.news?.isTrendingNews}
                onChange={e => setTrendingNews(e)}
              />
            </Form.Item>
            <Form.Item className={styles.audience} name="All Users">
              <span>Latest News</span>
              <Switch
                defaultChecked={data?.getNewsById?.news?.isSelectedNews}
                value={selectedNews}
                onChange={e => setSelectedNews(e)}
              />
            </Form.Item>
          </div>
          <Form.Item name="button">
            <Button label="Update News" onClick={handleAddNews} />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default EditNews;
